import { useEffect } from "react";
import { LocalizationLanguageStatus } from "@evennt-tech/api-v2-core";
import { useLocalizationLanguageStore } from "store/localization/localization-language-admin.store";

export const usePublishedLanguages = () => {
  const { languages, isLoading, fetchLanguages } = useLocalizationLanguageStore(
    (state) => ({
      languages: state.languages,
      isLoading: state.isLanguagesLoading,
      fetchLanguages: state.fetchLanguages,
    })
  );

  useEffect(() => {
    fetchLanguages();
  }, [fetchLanguages]);

  const publishedLanguages = languages.filter(
    (language) => language.status === LocalizationLanguageStatus.Published
  );

  return {
    languages: publishedLanguages,
    codes: publishedLanguages.map((language) => language.code),
    isLoading,
  };
};
